import axios from 'axios'
import { ObjectWithId } from '../classes/datamodel'
import store from '@/store/store'

let apiUrl = 'http://localhost:8081'

if (process.env) {
  // console.log('process.env.NODE_ENV = ', process.env.NODE_ENV)
  // console.log('process.env.VUE_APP_API_URL = ', process.env.VUE_APP_API_URL)
  // console.log('process.env.VUE_APP_ENV_TYPE = ', process.env.VUE_APP_ENV_TYPE)
  // console.log('process.env.VUE_APP_XTM_INTEGRATION_ACTIVE = ', process.env.VUE_APP_XTM_INTEGRATION_ACTIVE)

  if (process.env.NODE_ENV == 'production') {
      apiUrl = process.env.VUE_APP_API_URL
  }
}

const apiClient = axios.create({
  baseURL: apiUrl,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})


var activeRequests = 0 // counter of active requests
const sessionRenewalDelay = 30000 // in ms
var lastSessionRenewal = new Date().getTime() // in ms since epoch


////////////////// Request interceptor: ////////////////////
apiClient.interceptors.request.use(function (config) {
  // if this is not a session renewal request, we increment the active requests counter
  // if (config.url != 'renewSession' && config.url != '/renewSession') {
    activeRequests++
  // }
  // we encode the URL
  // console.log('config.url = ', config.url)
  // we do the following because encodeURI doesn't encode the +, and the server gets a space instead
  config.url = encodeURI(config.url).split('+').join('%2B') 
  console.log(`\n\n\n\n> Axios interceptor/request (${activeRequests} active requests): ${config.method.toUpperCase()}/${config.url}`)
  return config

}, function (error) {
  throw error
})


export default {
  async register (payload) {
    console.log('> Register payload: ', payload)
    try {
      const response = await apiClient.post('/incentifyer/register', payload)
      console.log('response = ', response)
      return response.data
    }
    catch (error) {
      console.log('!!ERROR> response: ', error)
      return error
    }
  },

  ////////////////////////////////////////////// Session stuff: //////////////////////////////////////////////
  async login (payload) {
    try {
      console.log('> Login payload: ', payload)
      const response = await apiClient.post('/incentifyer/login', payload)
      // lastSessionRenewal = new Date().getTime()
      console.log('> Login response: ', response)
      return response.data
    }
    catch (error) {
      console.log('> Login error, error = ', error)
      return errorHandler(error.response ? error.response.data : error)
    }
  },
  async changePassword (password) {
    return apiClient.post('/incentifyer/password', { password })
  },
  async logout (payload) {
    return apiClient.post('/incentifyer/logout', payload)
  },
  setDefaultToken (token) {
    setDefaultToken(token)
  },
  removeDefaultToken () {
    removeDefaultToken()
  }, 
  async renewSession () {
    try {
      const res = await apiClient.get('/incentifyer/renewSession')
      console.log('renewSession(): 2, res: ', res)
      return true
    }
    catch (e) {
      console.log('apiServices.renewSession(): catch')
      return errorHandler(e)
    }
  },
  async isSessionValid () {
    try {
      const res = await apiClient.get('/incentifyer/isSessionValid')
      console.log('apiServices.isSessionValid(): res = ', res)
      return res.data.result || false
    }
    catch (e) {
      console.log('apiServices.isSessionValid() > catch, e = ', e)
      return false
    }
  },

  ////////////////////////////////////////////// Affiliates invitations: //////////////////////////////////////////////
  async inviteAffiliate (incentifyerAffiliateInvitation) {
    try {
      const res = await apiClient.post('/incentifyer/inviteAffiliate', { incentifyerAffiliateInvitation })
      return res.data
    }
    catch (e) {
      console.log('apiServices.inviteAffiliate(): catch')
      return errorHandler(e)
    }
  },

  ////////////////////////////////////////////// Affiliates Revoking: //////////////////////////////////////////////
  async revokeAffiliate (affiliateAccountId, affiliateIncentifyerRelationshipId) {
    try {
      // alert(affiliateIncentifyerRelationshipId)
      const res = await apiClient.put('/incentifyer/revokeAffiliate', { affiliateAccountId, affiliateIncentifyerRelationshipId })
      return res.data
    }
    catch (e) {
      console.log('apiServices.inviteAffiliate(): catch')
      return errorHandler(e)
    }
  },
  
  /////////////////////////////////////////////// Resend Invitation: ///////////////////////////////////////////////
  async resendInvitation (payload) {
    try {
      const res = await apiClient.post('/incentifyer/resendInvitation', payload)
      console.log('resendInvitation res.data = ', res.data)
      return res.data
    }
    catch (e) {
      console.log('apiServices.resendInvitation(): catch')
      return errorHandler(e)
    }
  },

  ////////////////////////////////////////////// Data: /////////////////////////////////////////////////////////////
  async fetchData (period, scope) {
    try {
      const res = await apiClient.get(`incentifyer/fetchDataset?period=${period}${scope?'&scope='+scope:''}`)
      return res
    }
    catch (e) {
      return errorHandler(e)
    }
  },





  ////////////////////////////////////////////// Invoices: //////////////////////////////////////////////
async createPayoutsInvoice () {
  try {
    const res = await apiClient.post(`incentifyer/createPayoutsInvoice`)
    return res
  }
  catch (e) {
    return errorHandler(e)
  }
},



  ////////////////////////////////////////////// Base data: //////////////////////////////////////////////


  async getBaseData () {
    try {
      const res = await apiClient.get('/incentifyer/baseData')
      console.log('getBaseData(): ', res.data)
      return res.data
    } catch (e) {
      console.log('error in apiServices.js: getBaseData(): ', e)
    }
  },
  
  async saveSpiffsLeadsSetup (obj) {
    try {
      const res = await apiClient.put('/incentifyer/spiffsLeadsSetup', { spiffsLeadsSetup: obj })
      return res
    }
    catch (e) {
      console.log(`apiServices.saveSpiffsLeadsSetup(): catch = `, e)
      return errorHandler(e)
    }
  },
  
  async saveAccountProfile (obj) {
    try {
      const res = await apiClient.put('/incentifyer/accountProfile', { accountProfile: obj })
      return res
    }
    catch (e) {
      console.log(`apiServices.saveAccountProfile(): catch = `, e)
      return errorHandler(e)
    }
  },

  async saveAccountSetup (obj) {
    try {
      const res = await apiClient.put('/incentifyer/accountSetup', { accountSetup: obj })
      return res
    }
    catch (e) {
      console.log(`apiServices.saveAccountSetup(): catch = `, e)
      return errorHandler(e)
    }
  },




    ////////////////////////////////////////////// Rest stuff: //////////////////////////////////////////////


  async updateRestObject (object) {
    //console.log('apiServices.js: updateRestObject(): object = ', object instanceof ObjectWithId)
    if (!(object instanceof ObjectWithId && object._restVariableName)) {
      return {errors: [`Can't update an object of class ${object.constructor.name}, it's not a RestObject.`]}
    }
    try {
      const payload = {}
      payload[object._restVariableName] = object
      console.log('object = ', object)
      console.log('object.constructor.name = ', object.constructor.name)
      let res = await apiClient.put(`/incentifyer/rest/${getEndpointFromObject(object)}`, payload)
      console.log('apiServices.updateRestObject() res = ', res)
      return res.data
    }
    catch (e) {
      return errorHandler(e)
    }
  },

  async createRestObject (object) {
    if (!(object instanceof ObjectWithId && object._restVariableName)) {
      return {errors: [`Can't create an object of class ${object.constructor.name}, it's not a RestObject.`]}
    }
    try {
      const payload = {}
      payload[object._restVariableName] = object
      console.log('object = ', object)
      console.log('object.constructor.name = ', object.constructor.name)
      let res = await apiClient.post(`/incentifyer/rest/${getEndpointFromObject(object)}`, payload)
      return res.data
    }
    catch (e) {
      return errorHandler(e)
    }
  },

  async getRestObject (object) {
    if (!(object instanceof ObjectWithId && object._restVariableName)) {
      return {errors: [`Can't get an object of class ${object.constructor.name}, it's not a RestObject.`]}
    }
    try {
      let res = await apiClient.get(`/incentifyer/rest/${getEndpointFromObject(object)}/${object.id}`, object)
      return res.data
    }
    catch (e) {
      return errorHandler(e)
    }
  },

  async getRestObjects (object) {
    if (!(object instanceof ObjectWithId && object._restVariableName)) {
      return {errors: [`Can't get an objects of class ${object.constructor.name}, it's not a RestObject.`]}
    }
    try {
      let res = await apiClient.get(`/incentifyer/rest/${getEndpointFromObject(object)}`, object)
      return res.data
    }
    catch (e) {
      return errorHandler(e)
    }
  }


}

////////////////// Response interceptor: ////////////////////
apiClient.interceptors.response.use(async function (response) {
  // if this was not a session renewal request, we decrement the active requests counter
  // if (response.config && !['renewSession', '/renewSession'].includes(response.config.url)) {
    activeRequests--
  // }
  console.log(`> Axios interceptor/response (${activeRequests} active requests): `, response)
  // we convert the dates
  response.data && typeof response.data == 'object' ? stringdatesToDates(response.data) : null
  // If there's a new session in the response, we'll update it locally
  if (response.data.userSession && response.data.userSession.token) {
    console.log('setting new default token and updating local storage session')
    setDefaultToken(response.data.userSession.token)
    lastSessionRenewal = new Date().getTime()
    store.commit('STORE_SESSION', response.data.userSession)
  }
  // if it's the last active request, we'll renew the session if it hasn't been renewed recently
  if (activeRequests == 0 && (new Date().getTime() - lastSessionRenewal > sessionRenewalDelay)) {
    await apiClient.get('/incentifyer/renewSession')
  }
  return response

}, function (error) {
  // if this was not a session renewal request, we decrement the active requests counter
  // if (error.response.config && !['renewSession', '/renewSession'].includes(error.response.config.url)) {
    activeRequests--
  // }
  console.log(`interceptor/response ERROR (${activeRequests} active requests): `, error)
  const data = error.response ? error.response.data || '' : ''
  // If there's a new session in the response, we'll update it
  if (data && data.userSession && data.userSession.token) {
    setDefaultToken(data.userSession.token)
    store.commit('STORE_SESSION', data.userSession)
  }
  // If there's a session issue, we clear it and log the user out
  if (error.response && error.response.status == 401) {
    removeDefaultToken()
    store.dispatch('logout')
    // store.commit('CLEAR_SESSION')
  }
  throw error
})








/////////////////////////////////////////////////////////
/////////////////// private methods: ////////////////////
/////////////////////////////////////////////////////////

/** This method will convert all string dates from the object into Date objects */
function stringdatesToDates (object, depth = 0) {
  //console.log('stringdatesToDates(): object = ', object, '\n[depth = ', depth)
  // TO IMPROVE: call this recursive fonction only on objects that need it, like BaseData
  // we convert any string date into a Date
  for (let entry of Object.entries(object)) {
    // console.log('entry[1] = ', entry[1], ', ', new Date(entry[1]).toJSON())
    if (typeof entry[1] == 'string' && /^[0-9]{4}-[0-9]{1,2}-[0-9]{1,2}T[0-9:.]*Z$/.test(entry[1]) && (new Date(entry[1])).toJSON()) { // the .toJSON() is to convert 'Invalid Date' to null
      object[entry[0]] = new Date(entry[1])
    }
    else if (depth <= 3 && entry[1] && typeof entry[1] == 'object' && !(entry[1] instanceof Date)) {
      stringdatesToDates(entry[1], depth+1)
    }
  }
  return object
}

function setDefaultToken (token) {
  // console.log('setDefaultToken: ', token)
  apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

function removeDefaultToken () {
  apiClient.defaults.headers.common['Authorization'] = ``
}

function getEndpointFromObject(object) {
  // return object.constructor.name // this doesn't work because vuejs minimisation changes class names
  try {
    return object._restVariableName.charAt(0).toUpperCase() + object._restVariableName.slice(1)
  }
  catch(e) {
    console.log(`Error while trying to get endpoint from object:`, object)
    console.log(e)
    throw e
  }
}


function errorHandler (e) {
  console.log('> errorHandler(): ', e)
  if (e.errors && e.errors[0]) { // internal format
    //return e.errors.reducs((accu, current) => `${accu}, ${current}`)
    return e
  }
  else { // axios format
    const data = e.response && e.response.data ? e.response.data : ''
    return {errors: [data && data.errors ? data.errors[0] : e], status: e.response && e.response.status ? e.response.status : 400} // this works with $notify, but it expects strings..
  }
}